import { Preloader } from '@cian/preloader-component';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import * as styles from './FiltersSearchButton.css';

export enum EFilterSearchButtonIcons {
  List,
  Pin,
}

export interface IFiltersSearchButtonProps {
  href: string;
  title: string;
  text: string;
  dataMark: string;
  icon?: EFilterSearchButtonIcons;
  isLoading?: boolean;
  isLight?: boolean;
  onClick?(e: React.SyntheticEvent<HTMLElement>): void;
}

export function FiltersSearchButton({
  href,
  text,
  title,
  dataMark,
  icon,
  isLight,
  isLoading,
  onClick,
}: IFiltersSearchButtonProps) {
  const loaderColor = isLight ? '#2b87db' : '#fff';

  const iconClassname = React.useMemo(() => {
    switch (icon) {
      case EFilterSearchButtonIcons.List:
        return styles['icon--list'];
      case EFilterSearchButtonIcons.Pin:
        return styles['icon--pin'];
      default:
        return undefined;
    }
  }, [icon]);

  return (
    <span className={styles['container']}>
      <a
        {...mergeStyles(styles['button'], isLoading && styles['button--loading'], isLight && styles['button--light'])}
        href={href}
        title={title}
        data-mark={dataMark}
        onClick={onClick}
      >
        {iconClassname && (
          <span {...mergeStyles(styles['icon'], iconClassname)}/>
        )}
        {text}
        {isLoading && (
          <span className={styles['preloader']}>
            <Preloader size={18} stopColorForOffset0={loaderColor} stopColorForOffset1={loaderColor} />
          </span>
        )}
      </a>
    </span>
  );
}
